export class PlanOption {
    public planOptionId: number;
    public optionNumber: string;
    public optionName: string;
    public displayText: string;
    public qty: number;
    public listPrice: number;
    public optionCategoryId: number;
    public optionCategoryName: string;
    public isBaseHouse: boolean;
    public maxOrderQty: number;
    public action: string;
    public planId: number;
}
